export default __webpack_public_path__ + "static/2-ee0470355c3729e0ca386ec6350d44d3.gif";